import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import { BASE_API_URL } from "../../utils/constants";

const baseURL = BASE_API_URL;

export const adminUserSlice = createSlice({
  name: "AdminUser",
  initialState: {
    error: false,
    assignedTracks: [],
    isLoaded: false,
    isDataSentSuccess: false,
    isDataSentFailure: false,
    adminUsers: []
  },
  reducers: {
    setAssignedTracks: (state, { payload }) => {
      state.error = false;
      state.assignedTracks = payload;
    },
    setError: (state) => {
      state.error = true;
    },
    setLoaded: (state, { payload }) => {
      state.isLoaded = true;
      state.isDataSentSuccess = false;
      state.isDataSentFailure = false;
    },
    setDataSuccess: (state, { payload }) => {
      console.log('payload', payload)
      state.isLoaded = false;
      state.isDataSentSuccess = payload;
      state.isDataSentFailure = false;
    },
    setDataFailure: (state, payload) => {
      state.isLoaded = false;
      state.isDataSentSuccess = false;
      state.isDataSentFailure = true;
    },
    setAdminUsers: (state, payload) => {
      state.error = false;
      state.adminUsers = payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setAssignedTracks, setError, setLoaded, setDataFailure, setDataSuccess,setAdminUsers } =
  adminUserSlice.actions;

export default adminUserSlice.reducer;

export function addAdminUser(payload) {
  return (dispatch) => {
    dispatch(setLoaded())
    Axios.post(
      `${baseURL}/addUser`,
      { payload },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setDataSuccess(res.data.message))
        console.log("res from getnomination list based on skills", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        dispatch(setDataFailure())
        console.error("error is", err);
      });
  };
}
export const fetchAdminUser = (eid) => {
  return (dispatch) => {
    Axios.get(`${baseURL}/adminUser/${eid}`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.data.length > 0) {
          dispatch(setAssignedTracks(res.data[0].tracks));
        }
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
};

export const fetchAdminUsers = () => {
  return (dispatch) => {
    Axios.get(`${baseURL}/fetchAdminUsers`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.data.length > 0) {
          dispatch(setAdminUsers(res.data));
        }
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
};
